import { addLog } from 'assets/components/feedback/Feedback';
import ModalForm from 'assets/components/form/modalForm/ModalForm';
import ThemeModalFormDefault from 'assets/components/form/modalForm/themes/Theme.ModalForm.Default';
import Icon from 'assets/components/icon/Icon';
import SelectInput from 'assets/components/inputs/select/SelectInput';
import TextInput from 'assets/components/inputs/text/TextInput';
import FormWrapper from 'assets/components/inputs/wrappers/FormWrapper';
import { getLocales } from 'assets/locales/Locale';
import { formatFormPhone } from 'assets/utils/forms/formatFormPhone';
import { isEmail, isValidPhoneNumber } from 'assets/utils/parsersAndValidation/Validators';
import { HttpStatus } from 'config/Api.Config';
import { values } from 'lodash';
import ContractConsentRequestType from 'models/enums/ContractConsentRequestType';
import contractConsentResendApi from 'models/sales/contractConsent/resend/Api.ContractConsent.Resend';
import { SalesContractAction, useSalesContractProvider } from '../../Sales.Contract.Hooks';

export type ContractResendConsentForm = Api.Core.ContractConsent.Resend.IParams &
  Api.Core.ContractConsent.Resend.IRequest;
const ContractResendConsent = () => {
  const { lang } = getLocales();
  const { selected, findApi, listApi, pageRouter } = useSalesContractProvider();

  return (
    <ModalForm<ContractResendConsentForm>
      subcomponents={ThemeModalFormDefault}
      dependencyArray={[selected]}
      title={lang.resendConsent}
      default={{
        id: selected?.contractConsentId ?? selected?.contractConsent?.id,
        requestType: selected?.contractConsent?.type ?? ContractConsentRequestType.EMAIL,
        customerEmail: selected?.contractConsent?.customerEmail,
        customerPhoneNumber: selected?.contractConsent?.customerPhoneNumber ?? selected?.client?.phone,
      }}
      onCancel={() => pageRouter.updateParams({ id: selected?.id?.toString(), action: SalesContractAction.INFO })}
      onSubmit={async ({ id, requestType, customerEmail, customerPhoneNumber }) => {
        const res = await contractConsentResendApi({ id, requestType }, { customerEmail, customerPhoneNumber });
        if (res.status !== HttpStatus.ok) addLog({ error: res.message });
        else {
          addLog({ success: lang.saveSuccess });
          pageRouter.updateParams({ id: selected.id.toString(), action: SalesContractAction.INFO });
          listApi.execute((body) => body);
          findApi.execute((body) => body);
        }
      }}
      validation={(data, errors) => {
        if (!data.requestType) errors.requestType = lang.required;
        if (!data.customerEmail && data.requestType === ContractConsentRequestType.EMAIL)
          errors.customerEmail = lang.required;
        if (!data.customerPhoneNumber && data.requestType === ContractConsentRequestType.TEXT)
          errors.customerPhoneNumber = lang.required;
        if (data.customerEmail && !isEmail(data.customerEmail)) errors.customerEmail = lang.invalidEmailFormatRequires;
        if (data.customerPhoneNumber && !isValidPhoneNumber(data.customerPhoneNumber))
          errors.customerPhoneNumber = lang.invalidFormatRequires.replace('{format}', '###-###-####');
      }}
      render={({ form }) => (
        <FormWrapper>
          <SelectInput
            name="requestType"
            data={values(ContractConsentRequestType).map((it) => ({
              id: it,
              title: it.toUpperCase(),
            }))}
            value={form.data?.requestType}
            onChange={form.update}
            error={form.errors.requestType}
            label={lang.type}
            icon={<Icon class="fas-envelope" />}
          />
          <TextInput
            name="data"
            label={form.data.requestType === ContractConsentRequestType.EMAIL ? lang.email : lang.phoneNumber}
            value={
              form.data.requestType === ContractConsentRequestType.EMAIL
                ? form.data?.customerEmail
                : form.data?.customerPhoneNumber
            }
            error={
              form.data.requestType === ContractConsentRequestType.EMAIL
                ? form.errors?.customerEmail
                : form.errors?.customerPhoneNumber
            }
            onChange={({ data }) =>
              form.data.requestType === ContractConsentRequestType.EMAIL
                ? form.update({ customerEmail: data })
                : form.update({ customerPhoneNumber: formatFormPhone(form.data.customerPhoneNumber, data) })
            }
            icon={<Icon class="if-quill-pen" />}
          />
        </FormWrapper>
      )}
    />
  );
};

export default ContractResendConsent;
